
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/created",
      function () {
        return require("private-next-pages/created.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/created"])
      });
    }
  